import { useEffect, useState } from "react";
import { getData } from "../utils/apiCalls";
import { CarouselSlider } from './CarouselSlider';
import { Loader } from "./Loader";
import testimonial from '../data/testimonials_home.json'

export const TestimonialCarousel = ({ pageName }) => {
   const [data, setData] = useState([])
   // const [isLoading, setIsLoading] = useState(true)

   useEffect(() => {
      setData(testimonial)
      // getData('https://youngstartup.io/api/cwebsite/get_testimonials?page=' + pageName)
      //    .then(res => { setData(res) })
      //    .then(() => { setIsLoading(false) })
   }, [pageName]);

   return (
      <div className="testimonial-carousel">
         {/* {isLoading && <Loader color='dark1' />} */}
         {<CarouselSlider data={data} >
            {
               data.map((item, index) => (
                  <div key={index} className='testimonial-slide'>
                     <section className="testimonial">
                        <h1>"{item.content}"</h1>
                        <h5>{item.name}, {item.company}</h5>
                        <img src={item.image_url} alt={`${item.name}, from ${item.company}, head shot image`} />
                     </section>
                  </div>
               ))
            }
         </CarouselSlider>}
      </div>
   )
}
